import {
  Box,
  LinearProgress,
  Paper,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { palette, theme as colorTheme } from "../../../Convoze.theme";

const primary = colorTheme('palette', 'primary').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;


const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: "#E5E7EB",
  "& .MuiLinearProgress-bar": {
    borderRadius: 4,
    backgroundColor: primary,
  },
  [theme.breakpoints.down("sm")]: {
    height: 6,
  },
}));

const ProgressLabel = styled(Box)(({ theme }) => ({
  display: "inline-block",
  backgroundColor: "#EEF0FE",
  color: primary,
  padding: theme.spacing(0.5, 1),
  borderRadius: 5,
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  // marginBottom: theme.spacing(1),
}));

function ProgressBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  // Progress data
  const progressData = {
    completed: 3,
    remaining: 3,
    total: 6,
    percentage: 50,
    status: "IN PROGRESS",
    date: "June 15, 2023",
  };
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          //   justifyContent: "space-between",
          // gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 5,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h6"}
            component="h1"
            fontWeight="600"
            color="text.primary"
            sx={{ textAlign: isMobile ? "center" : "left" }}
          >
            Your Progress
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: isMobile ? "0.875rem" : "1rem",
              textAlign: isMobile ? "center" : "right",
            }}
          >
            {progressData?.date}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
            mb: 1.2,
          }}
        >
          <ProgressLabel>{progressData?.status}</ProgressLabel>
          <Typography
            variant="body1"
            fontWeight="600"
            color={primary}
            sx={{
              fontSize: isMobile ? "1rem" : "1.125rem",
            }}
          >
            {progressData?.percentage}%
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <StyledLinearProgress
            variant="determinate"
            value={progressData.percentage}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: isMobile ? "0.875rem" : "1rem",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <Typography component="span" color={primary} fontWeight="600">
              {progressData?.completed}
            </Typography>{" "}
            completed
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: isMobile ? "0.875rem" : "1rem",
              textAlign: isMobile ? "center" : "right",
            }}
          >
            <Typography component="span" color="text.primary" fontWeight="600">
              {progressData.remaining}
            </Typography>{" "}
            remaining
          </Typography>
        </Box>
      </Paper>
    </>
  );
}

export default ProgressBar;
